/*
 *
 * PatientDetailsPage reducer
 *
 */
import * as Constants from './constants';

const initialState = {
  appointments: [],
  isLoading: false,
  facets: [],
  patients: [],
  dates: [],
  isFetchingAppointments: false,
  ehrActivityCount: 0,
  page: 0,
  totalPages: 0,
  lastPage: false,
};

export const patientDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_PROVIDER_SEARCH_REQUEST_SENT:
    case Constants.GET_PROVIDER_FILTERS_REQUEST_SENT:
    case Constants.GET_PROVIDER_FILTERS_REQUEST_FAILED:
    case Constants.GET_PROVIDER_SEARCH_REQUEST_FAILED:
    case Constants.GET_PROVIDER_PATIENTS_RANGE_REQUEST_FAILED:
    case Constants.GET_PROVIDER_PATIENTS_RANGE_REQUEST_SENT:
    case Constants.GET_EHR_ACTIVITY_REQUEST_SENT:
    case Constants.GET_EHR_ACTIVITY_REQUEST_FAILED:
      return {
        ...state,
        isLoading: true
      };
    case Constants.GET_APPOINTMENTS_SEARCH_WITHIN_RANGE_REQUEST_SENT:
      return {
        ...state,
        isFetchingAppointments: true,
      };
    case Constants.GET_APPOINTMENTS_SEARCH_WITHIN_RANGE_REQUEST_FAILED:
      return {
        ...state,
        isFetchingAppointments: false,
      };
    case Constants.GET_APPOINTMENTS_SEARCH_REQUEST_FAILED:
      return {
        ...state,
        isFetchingAppointments: false,
      };
    case Constants.GET_APPOINTMENTS_SEARCH_REQUEST_SENT:
      return {
        ...state,
        isFetchingAppointments: true,
      };
    case Constants.GET_PROVIDER_FILTERS_REQUEST_SUCCEED:
      return {
        ...state,
        isLoading: false,
        facets: [...action.payload.facets],
      };
    case Constants.GET_APPOINTMENTS_SEARCH_WITHIN_RANGE_REQUEST_SUCCEED:
      return {
        ...state,
        dates: [...action.dates.dates],
        isFetchingAppointments: false,
      };
    case Constants.GET_APPOINTMENTS_SEARCH_REQUEST_SUCCEED:
      return {
        ...state,
        isLoading: false,
        isFetchingAppointments: false,
        appointments: [
          ...state.appointments,
          ...action.payload.appointments,
        ],
        page: action.payload.page,
        lastPage: action.payload.lastPage,
        totalPages: action.payload.totalPages
      };
    case Constants.GET_EHR_ACTIVITY_REQUEST_SUCCEED:
      return {
        ...state,
        isLoading: false,
        ehrActivityCount: action.data.count,
      };
    case Constants.CLEAR_PREVIOUS_APPOINTMENTS:
      return {
        ...state,
        appointments: []
      }
    default:
      return state;
  }
};

const addNewPatientInitialState = {
  // isLoading: false,
  show: false,
  isRequestInProgress: false,
};

export const addNewPatientReducer = (state = addNewPatientInitialState, action) => {
  switch (action.type) {
    case Constants.ADD_NEW_PATIENT_REQUEST_SENT:
      return {
        show: true,
        isRequestInProgress: true,
      };
    case Constants.ADD_NEW_PATIENT_REQUEST_SUCCEED:
      return {
        show: false,
        isRequestInProgress: false,
      };
    case Constants.ADD_NEW_PATIENT_REQUEST_FAILED:
      return {
        show: true,
        isRequestInProgress: false,
      };
    default:
      return state;
  }
};
